import { render, staticRenderFns } from "./ModalCompanyWhatsApp.vue?vue&type=template&id=24b8fa0c"
import script from "./ModalCompanyWhatsApp.vue?vue&type=script&lang=js"
export * from "./ModalCompanyWhatsApp.vue?vue&type=script&lang=js"
import style0 from "./ModalCompanyWhatsApp.vue?vue&type=style&index=0&id=24b8fa0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports